import { combineReducers } from 'redux'
import theme from './slices/themeSlice'
import auth from './slices/authSlice'
import exam from './slices/examSlice'
import session from './slices/sessionSlice'
import config from './slices/configSlice'
import file from './slices/fileSlice'

const rootReducer = (asyncReducers) => (state, action) => {
    const combinedReducer = combineReducers({
        theme,
        auth,
        exam,
        session,
        config,
        file,
        ...asyncReducers,
    })
    return combinedReducer(state, action)
}
  
export default rootReducer
